import { Stack, TextField } from "@mui/material";
import { Control, Controller, FormState } from "react-hook-form";
import { SmallInputLabel, TextEditor } from "..";

export interface ICreateEditProposalFormState {
  description: string;
  notes: string;
}

interface IProps {
  formState: FormState<ICreateEditProposalFormState>;
  control: Control<ICreateEditProposalFormState, any>;
}

const CreateEditProposalForm = (props: IProps) => {
  const {
    formState: { errors },
    control,
  } = props;

  return (
    <Stack spacing={1}>
      <Stack>
        <SmallInputLabel required>Description</SmallInputLabel>
        <Controller
          name="description"
          control={control}
          rules={{ required: "Description is required" }}
          render={({ field }) => (
            <TextField
              {...field}
              multiline
              placeholder="Enter a brief description of the proposal"
              error={!!errors.description}
              helperText={errors.description?.message}
              slotProps={{
                htmlInput: {
                  maxLength: 128,
                },
              }}
            />
          )}
        />
      </Stack>

      <Stack>
        <SmallInputLabel>Notes</SmallInputLabel>
        <Controller
          name="notes"
          control={control}
          render={({ field }) => (
            <TextEditor
              initialValue={field.value}
              onBlur={(value) => field.onChange(value)}
              placeholder="Add additional notes or details (optional)"
            />
          )}
        />
      </Stack>
    </Stack>
  );
};

export { CreateEditProposalForm };
